import COS from 'cos-js-sdk-v5';

import { UPLOAD_PATH } from '@/const/cdn';
import { getCos, StsType } from '@/services/cos';

/**
 * 获取cos临时密钥
 */
export const putCos = (
  path = UPLOAD_PATH,
  type?: StsType,
) => new COS({
  getAuthorization: async (_options, callback) => {
    const res = await getCos(path, type);
    const temRes = res;

    const tmpSecretId = temRes.data?.Credentials?.TmpSecretId;
    const tmpSecretKey = temRes.data?.Credentials?.TmpSecretKey;
    const sessionToken = temRes.data?.Credentials?.Token;
    const startTime = temRes.data?.StartTime;
    const expiredTime = temRes.data?.ExpiredTime;
    callback({
      TmpSecretId: tmpSecretId,
      TmpSecretKey: tmpSecretKey,
      SecurityToken: sessionToken,
      // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
      StartTime: startTime, // 时间戳，单位秒，如：1580000000
      ExpiredTime: expiredTime, // 时间戳，单位秒，如：1580000000
    });
  },
});
